import { FC } from 'react';
import { Kalenderhändelse } from '../../types/pages';
import styles from './KalenderHändelseDatum.module.css';

type KalenderHändelseDatumProps = {
  händelse: Kalenderhändelse;
};

const KalenderHändelseDatum: FC<KalenderHändelseDatumProps> = ({ händelse }) => {
  const formatDate = (date: Date, options: object): string => {
    return new Date(date).toLocaleDateString(navigator.language, options).slice(0, 3);
  };

  return (
    <div className={styles.container}>
      <span className={styles.month}>
        {formatDate(händelse.händelsedatum, { day: 'numeric' })}
      </span>
      <span className={styles.day}>
        {formatDate(händelse.händelsedatum, { month: 'short' })}
      </span>
    </div>
  );
};

export default KalenderHändelseDatum;
